import { MainGroupConfiguration } from "../../data";

export const MainGroupFunctions = {
    [MainGroupConfiguration.Sport]: {
        headings: "displaySports",
        events: "displayEventsBySportId"
    },
    [MainGroupConfiguration.League]: {
        headings: "displayLeagues",
        events: "displayEventsByLeague"
    },
    [MainGroupConfiguration.Day]: {
        headings: "displayDays",
        events: "displayEventsByDay"
    },
    [MainGroupConfiguration.Event]: {
        headings: "displayAllEvents",
        events: "displayEventsById"
    }
}